import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PestsIndex from "@/pages/PestsIndex";
import PestPage from "@/pages/PestPage";
import DIY from "@/pages/DIY";
import HireAPro from "@/pages/HireAPro";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import About from "@/pages/About";
import Pros from "@/pages/Pros";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import Funnel from "@/pages/Funnel";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/lp" element={<Funnel />} />
          <Route path="/lp/:pestSlug" element={<Funnel />} />
          <Route path="/lp/:pestSlug/:citySlug" element={<Funnel />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/pests" element={<PestsIndex />} />
            <Route path="/pests/:slug" element={<PestPage />} />
            <Route path="/diy" element={<DIY />} />
            <Route path="/hire-a-pro" element={<HireAPro />} />
            <Route path="/hire-a-pro/:pestSlug" element={<HireAPro />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/:slug" element={<GuideArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/pros" element={<Pros />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/terms" element={<Legal type="terms" />} />
            <Route path="/affiliate-disclosure" element={<Legal type="affiliate" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
